﻿<template>
    <!--TEMPORARY MESSAGE DURING PAYMENT FAILURES-->
    <div v-if="!isAgent_Login() && GetBrand() == 'HEX'" class="cart-addon">
        <p class="m-auto font-bold text-black pt-2 text-center">If you don't receive a confirmation email please contact us at info@highlandexplorertours.com</p>
    </div>
    <div v-if="!isAgent_Login() && GetBrand() == 'HAG'" class="cart-addon">
        <p class="m-auto font-bold text-black pt-2 text-center">If you don't receive a confirmation email please contact us at info@haggisadventures.com</p>
    </div>

    <section class="px-list" aria-labelledby="px-list-title">
        <div class="px-list-head">
            <h2 id="px-list-title">Passenger details</h2>
            <p>Enter the details for everyone travelling. Fields marked optional can be left blank.</p>
        </div>

        <div v-if="bookingStore.show_passenger_errors && Incomplete_Passengers.length > 0" class="px-summary" role="alert">
            <strong>
                {{ Incomplete_Passengers.length === 1 ? '1 passenger needs' : Incomplete_Passengers.length + ' passengers need' }}
                more details before you can continue
            </strong>
            <ul>
                <li v-for="item in Incomplete_Passengers" :key="item.passenger.passenger_identifier ?? item.index">
                    <button type="button" class="mb-link-btn" @click="Go_To_Passenger(item.passenger)">
                        {{ Passenger_Label(item) }}: {{ item.count }} {{ item.count === 1 ? 'field' : 'fields' }} to fix
                    </button>
                </li>
            </ul>
        </div>

        <passenger_form
            v-for="(p, index) in Passengers"
            :key="p.passenger_identifier ?? index"
            :passenger="p"
            :index="index"
            :countries="countries"
        ></passenger_form>
    </section>
</template>

<script lang="ts" src="./passengers.ts"></script>
